import { makeAutoObservable } from 'mobx';
import { BFFGet } from '@/infrastructure/axios';
import { API_PREFIX } from '@/infrastructure/axios/code';

type SystemSymbolConfig = {
  androidNativeSymbol: string[];
  androidStartSystemSymbol: string[];
  androidSystemSymbol: string[];
  harmonySystemSymbol: string[];
  iosSystemSymbol: string[];
};


export class AppStore {
  systemSymbolConfig?: SystemSymbolConfig = undefined;

  constructor() {
    makeAutoObservable(this, {}, { autoBind: true });
  }

  public async loadSymbols() {
    if (this.systemSymbolConfig !== undefined) {
      return this.systemSymbolConfig;
    }

    const res = await BFFGet(`/${API_PREFIX}/api/config/system-symbol`);
    const systemConfig = res.data || {};
    this.systemSymbolConfig = {
      androidNativeSymbol: systemConfig.android_native_key || [],
      androidStartSystemSymbol: systemConfig.android_sys_key?.split(';') ?? [],
      androidSystemSymbol: systemConfig.android_sys_symbols || [],
      harmonySystemSymbol: systemConfig.harmony_system_key || [],
      iosSystemSymbol: systemConfig.ios_sys_Key || [],
    };
    return this.systemSymbolConfig;
  }
}
